// composing functions, read from right to left
const compose = (...fns) => fns.reduce((f, g) => (...args) => f(g(...args)));

export default compose



// WEBPACK FOOTER //
// ./src/utils/compose.js